<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :search.sync="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot-scope="scope" slot="areaNameSearch">
        <el-select
          v-model="search.areaName"
          filterable
          @change="getTreeNode(3, search.areaName)"
          style="width: 100%;"
          placeholder="请选择小区"
        >
          <el-option
            v-for="item in allPropertyList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="buildingSearch">
        <el-select
          v-model="search.building"
          filterable
          @change="getTreeNode(4, search.building)"
          placeholder="请选择楼栋"
        >
          <el-option
            v-for="item in buildingList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="unitNameSearch">
        <el-select
          v-model="search.unitName"
          filterable
          @change="getTreeNode(6, search.unitName)"
          placeholder="请选择单元"
        >
          <el-option v-for="item in unitList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="roomIdSearch">
        <el-select v-model="search.roomId" filterable @change="saveRoomId" placeholder="请选择房间">
          <el-option v-for="item in roomList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permissionList.addBtn"
          @click="openIframe('add')"
          >新 增
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          v-if="permissionList.viewBtn"
          icon="el-icon-view"
          @click="openIframe('view', scope.row.id)"
          >查看</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permissionList.editBtn"
          @click="openIframe('edit', scope.row.id)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          v-if="permissionList.delBtn"
          @click="rowDel(scope.row)"
          style="color: #ff0000;"
          >删除</el-button
        >
      </template>
    </avue-crud>
    <el-dialog
      :title="addformTitle"
      :visible.sync="showAddform"
      :modal-append-to-body="false"
      width="60%"
    >
      <!-- 使用组件 -->
      <addform @closeAddform="closeAddform($event)"></addform>

      <router-link to=""></router-link>
    </el-dialog>
    <!--    查看-->
    <el-dialog
      :title="otherformTitle"
      :visible.sync="showOtherform"
      :before-close="closeOtherDialog"
      :operateType="operateType"
      :modal-append-to-body="false"
      width="60%"
    >
      <!-- 使用组件 -->
      <otherform
        :disabled="disabled"
        :operateType="operateType"
        :dataId="dataId"
        @closeOtherform="closeOtherform($event)"
        @closeRefreshOtherform="closeRefreshOtherform($event)"
      ></otherform>
      <router-link to=""></router-link>
    </el-dialog>
  </basic-container>
</template>

<script>
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import addform from './basebankaccount-add';
import otherform from './basebankaccount-form';
import { add, getDetail, getList, remove, update } from '@/api/v4ward/bankaccount/basebankaccount';
import { mapGetters } from 'vuex';
import {
  getTreeChildrenNode,
  getTreeChildrenPowerNode,
  treeChildrenPowerNodeCount,
} from '@/api/v4ward/property/baseproperty';
import { lazyBasePropertyTree } from '@/api/v4ward/property/baseproperty';

export default {
  components: {
    addform,
    otherform,
  },
  data() {
    return {
      disabled: false,
      search: {},
      allPropertyList: [],
      buildingList: [],
      unitList: [],
      roomList: [],
      basebankaccount_view: false,
      basebankaccount_edit: false,
      basebankaccount_delete: false,
      basebankaccount_add: false,
      deptProStatus: false,
      showAddform: false,
      showOtherform: false,
      propertyName: '',
      dataId: '',
      operateType: 'add',
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        menuPosition: 'center',
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        align: 'center',
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
        selection: true,
        columnBtn: false,
        searchMenuSpan:6,
        span: 6,
        column: [
          {
            hide: true,
            label: '小区名称',
            prop: 'areaName',
            type: 'select',
            searchslot: true,
            search: true,
          },
          {
            hide: true,
            label: '楼栋名称',
            prop: 'building',
            type: 'select',
            searchslot: true,
            search: true,
          },
          {
            hide: true,
            label: '单元名称',
            prop: 'unitName',
            type: 'select',
            searchslot: true,
            search: true,
          },
          {
            hide: true,
            label: '房间名称',
            prop: 'roomId',
            type: 'select',
            searchslot: true,
            search: true,
          },

          {
            label: '房产名称',
            prop: 'objectFullName',
          },
          {
            label: '账户名称',
            span: 10,
            prop: 'accountName',
            search: true,
          },
          {
            label: '扣款账户',
            span: 6,
            prop: 'accountNo',
            search: true,
          },
          {
            label: '扣款银行',
            type: 'select',
            search: true,
            prop: 'bankId',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=bill_cutBank',
            dataType: 'number',
          },
          //   {
          //     label: '开始时间',
          //     prop: 'beginTime',
          //     type: 'date',
          //     format: 'yyyy-MM-dd HH:mm:ss',
          //     valueFormat: 'yyyy-MM-dd HH:mm:ss',
          //   },
          //   {
          //     label: '禁用时间',
          //     prop: 'unuseTime',
          //     type: 'date',
          //     format: 'yyyy-MM-dd HH:mm:ss',
          //     valueFormat: 'yyyy-MM-dd HH:mm:ss',
          //   },
          {
            label: '最后操作人',
            prop: 'lastUserName',
          },
          //   {
          //     label: '是否禁用',
          //     prop: 'isStatus',
          //     type: 'select',
          //     dicData: [
          //       {
          //         label: '启用',
          //         value: 0,
          //       },
          //       {
          //         label: '禁用',
          //         value: 1,
          //       },
          //     ],
          //     hide: true,
          //     search: true,
          //   },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basebankaccount_add, this.basebankaccount_add),
        viewBtn: this.vaildData(this.permission.basebankaccount_view, this.basebankaccount_view),
        delBtn: this.vaildData(this.permission.basebankaccount_delete, this.basebankaccount_delete),
        editBtn: this.vaildData(this.permission.basebankaccount_edit, this.basebankaccount_edit),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initShowAddBtn();
    this.initPropertyList();
  },
  methods: {
    change1() {
      this.$forceUpdate();
    },
    saveRoomId(e) {
      this.$forceUpdate();
      this.form.roomId = e;
      this.query.roomId = e;
    },
    initPropertyList() {
      var that = this;
      getOptionNode({}).then((data) => {
        this.allPropertyList = data.data;
        this.allPropertyList[this.allPropertyList.length] = '全部';
      });
    },
    getTreeNode(type, id) {
      getTreeChildrenPowerNode({
        object_type: type,
        id: id,
      }).then((res) => {
        if (type == 3) {
          //楼栋下拉数据
          this.buildingList = res.data;
          this.unitList = [];
          this.roomList = [];
          this.search.building = '';
          this.search.unitName = '';
          this.search.roomId = '';
        } else if (type == 4) {
          //单元下拉数据
          this.unitList = res.data;
          this.search.unitName = '';
          this.search.roomId = '';
          this.roomList = [];
        } else if (type == 6) {
          //房间下拉数据
          this.search.roomId = '';
          this.roomList = res.data;
        } else {
          this.search.building = '';
          this.search.unitName = '';
          this.search.roomId = '';
        }
        this.change1();
      });
    },
    initShowAddBtn() {
      // treeChildrenPowerNodeCount({ power: 2 }).then(({ data }) => {
      //   if (data > 0) this.basebankaccount_add = true;
      // });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择的扣款账户删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.search = {};
      this.query = {};
      this.propertyName = '';
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;

      if (this.search.roomId) {
        this.query.roomId = this.search.roomId;
      } else if (this.search.unitName) {
        this.query.roomId = this.search.unitName;
      } else if (this.search.building) {
        this.query.roomId = this.search.building;
      } else if (this.search.areaName) {
        this.query.roomId = this.search.areaName;
      }

      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    //根据权限状态显示增删改查按钮
    // 若小区授权为1，查看变更可用，编辑和删除不可用；
    // 若小区授权为2，查看变更和编辑可用，删除不可用；
    // 若小区授权为1，查看变更可用，编辑和删除均可用；
    // showBtn(status) {
    //   if (status == 1) {
    //     this.deptProStatus = true;
    //     this.basebankaccount_view = true;
    //   } else if (status == 2) {
    //     this.deptProStatus = true;
    //     this.basebankaccount_view = true;
    //     this.basebankaccount_edit = true;
    //   } else if (status == 3) {
    //     this.deptProStatus = true;
    //     this.basebankaccount_view = true;
    //     this.basebankaccount_edit = true;
    //     this.basebankaccount_delete = true;
    //   }
    //},
    propertyNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];
      this.propertyName = nodeTitle;
      this.query.roomId = nodeId;
      if (this.propertyAddShowDialogFlag) {
        this.$refs.propertyAddParentNodeSelectRef.blur();
      }
    },
    //懒加载
    lazyLoadPropertyTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      getTreeChildrenPowerNode({ id: id, power: 1 }).then(({ data }) => {
        resolve(data);
      });
    },
    clearProperty() {
      this.propertyName = '';
      this.query.roomId = '';
    },
    ///////////////
    submitSearchForm() {
      this.searchChange(this.query);
    },
    openIframe(type, id) {
      if (type === 'edit') {
        this.disabled = false;
        this.otherformTitle = '扣款账户编辑';
        this.showOtherform = false;
        this.dataId = id;
        this.operateType = type;
        this.showOtherform = true;
      } else if (type === 'view') {
        this.disabled = true;
        this.otherformTitle = '扣款账户详情';
        this.showOtherform = false;
        this.dataId = id;
        this.operateType = type;
        this.showOtherform = true;
      } else if (type === 'add') {
        this.showAddform = false;
        this.addformTitle = '扣款账户新增';
        this.showAddform = true;
      }
    },
    closeAddform() {
      this.showAddform = false;
      //this.onLoad();
    },
    closeOtherform() {
      this.operateType = '';
      this.showOtherform = false;
    },
    closeRefreshOtherform() {
      this.operateType = '';
      this.showOtherform = false;
      this.onLoad();
    },
    closeOtherDialog() {
      this.operateType = '';
      this.showOtherform = false;
      //this.onLoad();
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  /* max-height: 274px; */
  padding: 5px;
  /* overflow: hidden; */
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
</style>
